var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPieSlice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 10V2.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4932 6.25L3.50879 13.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62605 11.375C2.54079 10.9217 2.49893 10.4613 2.50105 10C2.50007 8.4489 2.98052 6.93573 3.87611 5.6693C4.7717 4.40288 6.03828 3.44564 7.50105 2.92969V8.55469L2.62605 11.375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 2.5C11.3152 2.50015 12.6062 2.84561 13.7449 3.50179C14.8835 4.15797 15.8298 5.10183 16.4888 6.23881C17.1479 7.3758 17.4966 8.66601 17.5001 9.98019C17.5036 11.2944 17.1617 12.5864 16.5086 13.7269C15.8556 14.8673 14.9143 15.8162 13.7792 16.4783C12.644 17.1405 11.3548 17.4928 10.0406 17.4999C8.72642 17.507 7.43346 17.1686 6.29121 16.5187C5.14896 15.8688 4.19754 14.9302 3.53223 13.7969",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPieSlice);
export default __webpack_public_path__ + "static/media/ChartPieSlice.2850abf1c144803d0da65c85d2e88749.svg";
export { ForwardRef as ReactComponent };